import React from "react";

import { Skeleton } from "@packages/ds";

import * as S from "./BlackfireCard.styles";

const BlackfireCardSkeleton = () => (
  <Skeleton synchronize>
    <S.Layout>
      <Skeleton.Square height="24px" width="158px" margin="0 0 16px 0" />
      <Skeleton.Square height="24px" fixedWidth="100%" margin="0 0 72px 0" />
    </S.Layout>
  </Skeleton>
);

export default BlackfireCardSkeleton;
